import React from 'react';
import { Badge } from 'react-bootstrap';
import { motivosSerasaEnum } from '../../../../shared/constantes/motivosSerasaEnum';
import { motivosPh3aReceitaEnum } from '../../../../shared/constantes/motivosPh3aReceitaEnum';
import { motivosBmsPagamentosEnum } from '../../../../shared/constantes/motivosBmsPagamentosEnum';
import { ParametroDefinicaoDTO } from '../integracaoInterfaces';

interface MotivosGeraisProps {
    integracaoSelecionada: string;
    parametrosDefinicao: ParametroDefinicaoDTO[];
    listaMotivosInternos: any[];
    mapeamentoMotivosGerais: {[key: string]: string};
    setMapeamentoMotivosGerais: (v: {[key: string]: string}) => void;
}

const MotivosGeraisCard: React.FC<MotivosGeraisProps> = ({ 
    integracaoSelecionada, parametrosDefinicao, listaMotivosInternos, mapeamentoMotivosGerais, setMapeamentoMotivosGerais 
}) => {
    
    const renderStatusBadge = (idMotivo: string) => {
        if (!idMotivo) return null;
        const motivo = listaMotivosInternos.find(m => String(m.id) === String(idMotivo));
        
        if (motivo) {
            if (motivo.pendenciaRecusa === 'R') return <Badge bg="danger" className="ms-2">Reprova</Badge>;
            else return <Badge bg="warning" text="dark" className="ms-2">Pendência</Badge>;
        }
        return null;
    };

    let listaEnum: any[] = [];
    if (integracaoSelecionada.toLowerCase().includes('serasa')) listaEnum = motivosSerasaEnum;
    else if (integracaoSelecionada.toLowerCase().includes('ph3a')) listaEnum = motivosPh3aReceitaEnum;
    else if (integracaoSelecionada.toLowerCase().includes('bms')) listaEnum = motivosBmsPagamentosEnum;

    const defsGerais = parametrosDefinicao.filter(p => 
        p.tipoParametro === 'MOTIVO' && 
        listaEnum.some(e => e.descricaoBanco === p.nomeParametro)
    );

    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold">De/Para Motivos (Padrão)</div>
            <div className="card-body">
                {defsGerais.length === 0 ? <small className="text-muted">Nenhum motivo geral parametrizado.</small> : 
                    defsGerais.map(p => {
                        const label = listaEnum.find(m => m.descricaoBanco === p.nomeParametro)?.motivo || p.nomeParametro;
                        const labelTexto = label?.motivo || p.nomeParametro;
                        const valorSelecionado = mapeamentoMotivosGerais[p.nomeParametro] || '';
                        return (
                            <div className="row mb-2 align-items-center" key={p.id}>
                                <div className="col-5">
                                    <input className="form-control form-control-sm" value={labelTexto} disabled />
                                </div>
                                <div className="col-1 text-center">➡</div>
                                <div className="col-6 d-flex align-items-center">
                                    <div style={{ flexGrow: 1 }}>
                                        <select 
                                            className="form-select form-select-sm"
                                            value={valorSelecionado}
                                            onChange={e => setMapeamentoMotivosGerais({...mapeamentoMotivosGerais, [p.nomeParametro]: e.target.value})}
                                        >
                                            <option value="">Selecione Ação...</option>
                                            {listaMotivosInternos.map(m => <option key={m.id} value={m.id}>{m.descricao}</option>)}
                                        </select>
                                    </div>
                                    <div style={{ width: '80px', textAlign: 'left' }}>
                                        {renderStatusBadge(valorSelecionado)}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default MotivosGeraisCard;